export const hotelRegion: any = {
  hotelCountryList: "ホテルの目的国一覧",
  hotelRegionList: "{{country}}のホテルエリア一覧",
};
